<div class="spacer"></div>
<div class="container container-border container-size">
  <h2>{{ anwendungsname }}</h2>
</div>

<div class="spacer"></div>
<div class="container container-border container-size">
  <div class="row">
    <div class="col-md-12">
      <h4>Pseudonymisierung-Code</h4>
    </div>
  </div>
  <mat-card>
    <p>BMEL-Codes, die den Produktionsumfang beschreiben</p>

    <table style="width: 100%">
      <tr class="table-border">
        <th style="width: 10%">Code BMEL</th>
        <th style="width: 23.33%">Merkmal BMEL</th>
        <th style="width: 10%">Code BMEL</th>
        <th style="width: 23.33%">Merkmal BMEL</th>
        <th style="width: 10%">Code BMEL</th>
        <th style="width: 23.33%">Merkmal BMEL</th>
      </tr>
      <tr>
        <td>0001</td>
        <td>Buchstelle</td>
        <td>0003</td>
        <td>Land</td>
        <td>0005</td>
        <td>Landkreis, kreisfreie Stadt</td>
      </tr>
      <tr>
        <td>0002</td>
        <td>Betriebsnummer bei der Buchstelle</td>
        <td>0004</td>
        <td>Regierungsbezirk / Direktionsbezirk</td>
      </tr>
    </table>
    <br />

    <p>BMEL-Codes, die den Produktionsumfang beschreiben</p>

    <table style="width: 100%">
      <tr class="table-border">
        <th style="width: 10%">Code BMEL</th>
        <th style="width: 23.33%">Merkmal BMEL</th>
        <th style="width: 10%">Code BMEL</th>
        <th style="width: 23.33%">Merkmal BMEL</th>
        <th style="width: 10%">Code BMEL</th>
        <th style="width: 23.33%">Merkmal BMEL</th>
      </tr>
      <tr>
        <td>3100</td>
        <td>Ponys und Kleinpferde bis 1 Jahr</td>
        <td>3172</td>
        <td>Mutterziegen</td>
        <td>4056</td>
        <td>Hülsengemüse aus Feldanbau</td>
      </tr>
      <tr>
        <td>3101</td>
        <td>Ponys u. Kleinpferde über 1 bis 2 Jahre</td>
        <td>3173</td>
        <td>Sonstige Ziegen</td>
        <td>4057</td>
        <td>Sonstiges Gemüse aus Feldanbau</td>
      </tr>
      <tr>
        <td>3102</td>
        <td>Ponys u. Kleinpferde über 2 bis 3 Jahre</td>
        <td>3176</td>
        <td>Mastkaninchen</td>
        <td>4060</td>
        <td>Tabak</td>
      </tr>
      <tr>
        <td>3103</td>
        <td>Ponys u. Kleinpferde über 3 Jahre</td>
        <td>3177</td>
        <td>Zucht- und Angorakaninchen</td>
        <td>4061</td>
        <td>Grassamen</td>
      </tr>
      <tr>
        <td>3104</td>
        <td>Fohlen und Pferde bis 1 Jahr</td>
        <td>3181</td>
        <td>Bienenstöcke</td>
        <td>4062</td>
        <td>Sonstige Sämereien aus Feldanbau</td>
      </tr>
      <tr>
        <td>3105</td>
        <td>Pferde über 1 bis 2 Jahre</td>
        <td>3419</td>
        <td>Gemüse im Freilandanbau</td>
        <td>4063</td>
        <td>Arznei-, Gewürz-, Aroma- und Duftpflanzen</td>
      </tr>
      <tr>
        <td>3106</td>
        <td>Pferde über 2 bis 3 Jahre</td>
        <td>3429</td>
        <td>Gemüse in Gewächshäusern</td>
        <td>4064</td>
        <td>Sonstige Energiepflanzen</td>
      </tr>
      <tr>
        <td>3107</td>
        <td>Pferde über 3 Jahre</td>
        <td>3439</td>
        <td>Zierpflanzen im Freilandanbau</td>
        <td>4066</td>
        <td>Sonst. nachwachsende Rohstoffe</td>
      </tr>

      <tr>
        <td>3110</td>
        <td>Mastkälber</td>
        <td>4001</td>
        <td>Winterweizen, Dinkel</td>
        <td>4069</td>
        <td>Andere Handelsgewächse</td>
      </tr>
      <tr>
        <td>3111</td>
        <td>Weibliche Kälber bis 0,5 Jahre</td>
        <td>4002</td>
        <td>Sommerweizen</td>
        <td>4070</td>
        <td>Silomais, Lieschkolbenschrot</td>
      </tr>
      <tr>
        <td>3112</td>
        <td>Weibl. Jungrinder über 0,5 bis 1 Jahr</td>
        <td>4003</td>
        <td>Hartweizen, Durum</td>
        <td>4072</td>
        <td>Futterhackfrüchte</td>
      </tr>
      <tr>
        <td>3113</td>
        <td>Weibl. Jungrinder über 1 bis 2 Jahre</td>
        <td>4004</td>
        <td>Roggen</td>
        <td>4073</td>
        <td>Klee, Kleegras, Kleegemisch</td>
      </tr>
      <tr>
        <td>3114</td>
        <td>Zuchtfärsen</td>
        <td>4005</td>
        <td>Wintergerste</td>
        <td>4074</td>
        <td>Zwischenfrüchte</td>
      </tr>
      <tr>
        <td>3115</td>
        <td>Mastfärsen</td>
        <td>4006</td>
        <td>Sommergerste</td>
        <td>4074</td>
        <td>Zwischenfrüchte</td>
      </tr>
      <tr>
        <td>3116</td>
        <td>Milchkühe</td>
        <td>4007</td>
        <td>Hafer</td>
        <td>4075</td>
        <td>Ackerwiesen</td>
      </tr>
      <tr>
        <td>3117</td>
        <td>Ammen- und Mutterkühe</td>
        <td>4008</td>
        <td>Sommermenggetreide</td>
        <td>4076</td>
        <td>Dauerwiesen und Weiden</td>
      </tr>
      <tr>
        <td>3118</td>
        <td>Schlacht- und Mastkühe</td>
        <td>4009</td>
        <td>Wintermenggetreide</td>
        <td>4077</td>
        <td>Almen und Hutungen</td>
      </tr>
      <tr>
        <td>3120</td>
        <td>Männliche Kälber bis 0,5 Jahre</td>
        <td>4010</td>
        <td>Körnermais</td>
        <td>4078</td>
        <td>Getreidegrünfutter</td>
      </tr>
      <tr>
        <td>3121</td>
        <td>Männl. Jungrinder über 0,5 bis 1 Jahr</td>
        <td>4011</td>
        <td>CCM</td>
        <td>4078</td>
        <td>Getreidegrünfutter</td>
      </tr>
      <tr>
        <td>3122</td>
        <td>Männl. Jungrinder über 1 bis 1,5 Jahre</td>
        <td>4012</td>
        <td>Triticale</td>
        <td>4079</td>
        <td>Sonstige Futterpflanzen</td>
      </tr>
      <tr>
        <td>3123</td>
        <td>Männl. Jungrinder über 1,5 bis 2 Jahre</td>
        <td>4017</td>
        <td>Sonstiges Getreide</td>
        <td>4079</td>
        <td>Sonstige Futterpflanzen</td>
      </tr>
      <tr>
        <td>3124</td>
        <td>Männl. Mastrinder über 2 Jahre</td>
        <td>4020</td>
        <td>Ackerbohnen</td>
        <td>4080</td>
        <td>Hopfen</td>
      </tr>
      <tr>
        <td>3125</td>
        <td>Zuchtbullen</td>
        <td>4021</td>
        <td>Futtererbsen</td>
        <td>4088</td>
        <td>Sonstige landwirtschaftliche Kulturen</td>
      </tr>
      <tr>
        <td>3130</td>
        <td>Ferkel bis 10 kg</td>
        <td>4022</td>
        <td>Sonstige Hülsenfrüchte für Futterzwecke</td>
        <td>4098</td>
        <td>Brache</td>
      </tr>
      <tr>
        <td>3131</td>
        <td>Ferkel 10 bis 25 kg</td>
        <td>4023</td>
        <td>Sonstige Hülsenfrüchte</td>
        <td>4200</td>
        <td>Äpfel</td>
      </tr>
      <tr>
        <td>3133</td>
        <td>Läufer 25 bis 50 kg</td>
        <td>4024</td>
        <td>Winterraps</td>
        <td>4201</td>
        <td>Sonstiges Kernobst</td>
      </tr>
      <tr>
        <td>3134</td>
        <td>Mastschweine über 50 kg</td>
        <td>4025</td>
        <td>Sommerraps und Rübsen</td>
        <td>4202</td>
        <td>Süßkirschen</td>
      </tr>
      <tr>
        <td>3135</td>
        <td>Jungsauen</td>
        <td>4026</td>
        <td>Sonnenblumen</td>
        <td>4203</td>
        <td>Sauerkirschen, Schattenmorellen</td>
      </tr>
      <tr>
        <td>3136</td>
        <td>Zuchtsauen</td>
        <td>4027</td>
        <td>Sojabohnen</td>
        <td>4204</td>
        <td>Pflaumen und Zwetschgen</td>
      </tr>
      <tr>
        <td>3137</td>
        <td>Jungeber, 50 bis 120 kg</td>
        <td>4028</td>
        <td>Andere Ölsaaten (außer Öllein)</td>
        <td>4205</td>
        <td>Sonstiges Steinobst</td>
      </tr>
      <tr>
        <td>3138</td>
        <td>Zuchteber</td>
        <td>4029</td>
        <td>Faserpflanzen</td>
        <td>4206</td>
        <td>Schalenobst</td>
      </tr>
      <tr>
        <td>3140</td>
        <td>Lämmer bis 6 Monate</td>
        <td>4030</td>
        <td>Öllein</td>
        <td>4207</td>
        <td>Erdbeeren</td>
      </tr>
      <tr>
        <td>3141</td>
        <td>Jungschafe über 6 bis 12 Monate</td>
        <td>4031</td>
        <td>Energiegetreide</td>
        <td>4208</td>
        <td>Sonstige Beeren</td>
      </tr>
      <tr>
        <td>3142</td>
        <td>Jungschafe über 12 bis 20 Monate</td>
        <td>4032</td>
        <td>Energiemais</td>
        <td>4238</td>
        <td>Pilze</td>
      </tr>
      <tr>
        <td>3143</td>
        <td>Mutterschafe</td>
        <td>4033</td>
        <td>Energieeiweißpflanzen</td>
        <td>4291</td>
        <td>Ertragsrebfläche (ab 2. Standjahr)</td>
      </tr>
      <tr>
        <td>3144</td>
        <td>Zuchtböcke</td>
        <td>4034</td>
        <td>Energieölsaaten</td>
        <td>4295</td>
        <td>Junganlagen (1. Standjahr)</td>
      </tr>
      <tr>
        <td>3151</td>
        <td>Junghennen</td>
        <td>4035</td>
        <td>Energierüben</td>
        <td>4298</td>
        <td>Rebschnittgärten, Rebschule</td>
      </tr>
      <tr>
        <td>3152</td>
        <td>Legehennen</td>
        <td>4039</td>
        <td>Kartoffeln</td>
        <td>6111</td>
        <td>Baumschulfläche (GG)</td>
      </tr>
      <tr>
        <td>3153</td>
        <td>Jungmasthühner</td>
        <td>4040</td>
        <td>Zuckerrüben</td>
        <td>8019</td>
        <td>Zahl der Pensionspferde</td>
      </tr>
      <tr>
        <td>3154</td>
        <td>Mastenten</td>
        <td>4050</td>
        <td>Kohlgemüse aus Feldanbau</td>
        <td>8094</td>
        <td>Gemüse im Freiland</td>
      </tr>
      <tr>
        <td>3155</td>
        <td>Mastputen</td>
        <td>4051</td>
        <td>Blattgemüse aus Feldanbau</td>
        <td>8095</td>
        <td>Gemüse in Gewächshäusern</td>
      </tr>
      <tr>
        <td>3156</td>
        <td>Mastgänse</td>
        <td>4053</td>
        <td>Fruchtgemüse aus Feldanbau (z. B. Gurken)</td>
        <td>8096</td>
        <td>Zierpflanzen im Freiland</td>
      </tr>

      <tr>
        <td>3157</td>
        <td>Zuchtputen, -enten, -gänse</td>
        <td>4054</td>
        <td>Spargel aus Feldanbau</td>
        <td>8097</td>
        <td>Zierpflanzen in Gewächshäusern</td>
      </tr>
      <tr>
        <td>3159</td>
        <td>Sonstiges Geflügel</td>
        <td>4055</td>
        <td>Sonst. Knollen-, Wurzelgemüse a. Feldanbau</td>
        <td></td>
        <td></td>
      </tr>
    </table>
  </mat-card>

  <div class="spacer"></div>
  <mat-card>
    <div class="row">
      <div class="col-md-2">
        <button
          (click)="goBack()"
          mat-raised-button
          color="primary"
          class="custom-btn mt-3"
          type="button"
        >
          <fa-icon
            [icon]="faArrowLeft"
            class="ml-1 icon-vertical-align"
          ></fa-icon>
          Zurück
        </button>
      </div>
    </div>
  </mat-card>
</div>
<div class="spacer"></div>
